import axios from 'axios';
import { AppUser } from '../../views/App/App';
import { ALL_LIMIT } from '../../consts/table';

export function getCustomerPermissions(user: AppUser, customerId: string, filter) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
    params: {
      filter,
    },
  };

  return axios.get(`${window.apiBase}/admin/customers/${customerId}/permissions`, config).then(response => {
    return response.data;
  });
}

export function getAllCustomerPermissions(user: AppUser, customerId: string, where?) {
  const { sessionKey: key } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: {
            ...where,
          },
          limit: ALL_LIMIT,
          skip: 0,
        },
      },
    };
  } else {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          limit: ALL_LIMIT,
          skip: 0,
        },
      },
    };
  }

  return axios.get(`${window.apiBase}/admin/customers/${customerId}/permissions`, config).then(response => {
    return response.data;
  });
}

export function getCustomerPermissionsCount(user: AppUser, customerId: string, where?) {
  const { sessionKey: key } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: where,
        },
      },
    };
  } else {
    config = {
      headers: { usid: key },
    };
  }

  return axios.get(`${window.apiBase}/admin/customers/${customerId}/permissions/count`, config).then(response => {
    return response.data;
  });
}

export function addCustomerPermission(user: AppUser, customerId: string, data) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
  };

  return axios.post(`${window.apiBase}/admin/customers/${customerId}/permissions`, data, config).then(response => {
    return response.data;
  });
}

export function addCustomerPermissionsBulkImageId(user: AppUser, customerId: string, bulkImageId: string) {
  const { sessionKey: key } = user;
  const config = { headers: { usid: key } };
  return axios
    .post(`${window.apiBase}/admin/customers/${customerId}/permissions/bulkImageId`, { bulkImageId }, config)
    .then(r => r.data);
}

export function updateCustomerPermission(user: AppUser, customerId: string, permissionId: string, data) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
  };

  return axios
    .put(`${window.apiBase}/admin/customers/${customerId}/permissions/${permissionId}`, data, config)
    .then(response => {
      return response.data;
    });
}

export function deleteCustomerPermission(user: AppUser, customerId: string, permissionId: string) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
  };

  return axios
    .delete(`${window.apiBase}/admin/customers/${customerId}/permissions/${permissionId}`, config)
    .then(response => {
      return response.data;
    });
}
